import React, { useEffect, useState } from "react";
import Layout from "../../Components/Layout";
import { Icon } from "@iconify/react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";

// const activityLog = [
//   {
//     comment: "Project “i-HR” was created by Aniket Dange.",
//     timestamp: "11:11AM, 1 Dec '25",
//   },
//   {
//     comment: "Atul Thakur was assigned as Project Owner.",
//     timestamp: "11:11AM, 1 Dec '25",
//   },
//   {
//     comment: "Project scope and objectives were added to the description.",
//     timestamp: "11:11AM, 1 Dec '25",
//   },
//   {
//     comment: "Rahul Patil was added as Frontend Developer.",
//     timestamp: "11:11AM, 1 Dec '25",
//   },
//   {
//     comment: "Task “Fix login authentication bug” was created.",
//     timestamp: "11:11AM, 1 Dec '25",
//   },
//   {
//     comment: "Task assigned to Sandip Patil.",
//     timestamp: "11:11AM, 1 Dec '25",
//   },
//   {
//     comment: "Sandip Patil added a new comment.",
//     timestamp: "11:11AM, 1 Dec '25",
//   },
// ];
const tasks = [
  {
    name: "Fix login authentication bug",
    assignee: "Atul Thakur",
    dueDate: "28 Nov '25",
    status: "Done",
  },
  {
    name: "Implement payment gateway",
    assignee: "Sandip Patil",
    dueDate: "28 Nov '25",
    status: "Pending",
  },
  {
    name: "Fix login authentication bug",
    assignee: "Atul Thakur",
    dueDate: "28 Nov '25",
    status: "Done",
  },
  {
    name: "Implement payment gateway",
    assignee: "Sandip Patil",
    dueDate: "28 Nov '25",
    status: "Pending",
  },
  {
    name: "Fix login authentication bug",
    assignee: "Atul Thakur",
    dueDate: "28 Nov '25",
    status: "Done",
  },
  {
    name: "Implement payment gateway",
    assignee: "Sandip Patil",
    dueDate: "28 Nov '25",
    status: "Pending",
  },
  {
    name: "Fix login authentication bug",
    assignee: "Atul Thakur",
    dueDate: "28 Nov '25",
    status: "Done",
  },
  {
    name: "Implement payment gateway",
    assignee: "Sandip Patil",
    dueDate: "28 Nov '25",
    status: "Pending",
  },
  {
    name: "Fix login authentication bug",
    assignee: "Atul Thakur",
    dueDate: "28 Nov '25",
    status: "Done",
  },
  {
    name: "Implement payment gateway",
    assignee: "Sandip Patil",
    dueDate: "28 Nov '25",
    status: "Pending",
  },
  {
    name: "Fix login authentication bug",
    assignee: "Atul Thakur",
    dueDate: "28 Nov '25",
    status: "Done",
  },

  // Add more tasks up to 30+ for pagination testing
];
function ProjectDesc() {
  const navigate = useNavigate();
  const { id } = useParams();
  const [project, setProject] = useState(null);
  const [teamMembersId, setTeamMembersId] = useState([]);
  const [teamList, setTeamList] = useState([]);
  const [activityLog, setActivityLog] = useState([]);
  const [comment, setComment] = useState("");
  const [showMentions, setShowMentions] = useState(false);

  const token = localStorage.getItem("token");
  const [currentPage, setCurrentPage] = useState(1);
  const [expanded, setExpanded] = useState(true);

  const tasksPerPage = 10;

  // Fetch project details
  useEffect(() => {
    const fetchProject = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/projects/${id}`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        setProject(response.data);
        setActivityLog(response?.data?.projectsLogs || []);
        setTeamMembersId(response.data.teamId || []);
      } catch (error) {
        console.error("Error fetching project:", error);
      }
    };
    fetchProject();
  }, [id, token]);

  // Fetch employee list
  useEffect(() => {
    const featchuser = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/teams`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );

        setTeamList(response?.data?.content);
      } catch (error) {
        console.error("Error creating team:", error);
      }
    };
    featchuser();
  }, [token]);

  console.log(project, "project data");
  // Pagination
  const tasks = project?.tasks || [];
  const totalPages = Math.ceil(tasks.length / tasksPerPage);
  const startIndex = (currentPage - 1) * tasksPerPage;
  const currentTasks = tasks.slice(startIndex, startIndex + tasksPerPage);

  const handlePageChange = (page) => setCurrentPage(page);
  const handleAddMember = (e) => {
    const selectedId = parseInt(e.target.value);
    if (selectedId && !teamMembersId.includes(selectedId)) {
      setTeamMembersId([...teamMembersId, selectedId]);
    }
  };

  const handleRemoveMember = (id) => {
    setTeamMembersId(teamMembersId.filter((member) => member !== id));
  };
  const handleMentionClick = () => {
    setShowMentions(!showMentions);
  };

  const handleSelectEmployee = (emp) => {
    const mention = `@${emp.firstName}${emp.lastName} `;
    setComment((prev) => prev + mention);
    setShowMentions(false);
  };

  const handleSend = () => {
    if (comment.trim()) {
      console.log("Sending comment:", comment);
      setComment("");
    }
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setProject((prev) => ({ ...prev, [name]: value }));
  };

  // PATCH update project info
  const handleUpdateProject = async () => {
    try {
      const updatedData = {
        // projectName: project.projectName,
        projectDescription: project.projectDescription,
        ownerName: project.ownerName,
        status: project.status,
        startDate: project.startDate,
        endDate: project.endDate,
        teamId: teamMembersId,
      };
      await axios.patch(
        `${process.env.REACT_APP_BACKEND_URL}/projects/${id}`,
        updatedData,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      alert("Project updated successfully!");
    } catch (error) {
      console.error("Error updating project:", error);
    }
  };

  if (!project) return <p>Loading project...</p>;

  return (
    <Layout>
      <div className="backgound-main-content ">
        <Icon
          icon="material-symbols:arrow-back-rounded"
          width="24"
          height="24"
          className="back-icon"
          onClick={() => navigate(-1)}
        />
        <span className="back-text">Back</span>

        {/* Project Title */}
        <h4 className="mb-3">{project?.projectName}</h4>

        <div className=" d-flex ">
          <div className="col-8 m-1">
            {/* project description */}
            <div
              style={{
                border: "1px solid #D9D9D9",
                borderRadius: "10px",
                // backgroundColor: "#F6F6F6",
              }}
            >
              {/* Header */}
              <div
                className="d-flex justify-content-between align-items-center px-3 py-2"
                style={{
                  borderBottom: "1px solid #D9D9D9",
                }}
              >
                <h5 className="mb-0" style={{ color: "#606060" }}>
                  Project Description
                </h5>
                <button
                  className="btn btn-sm text-decoration-none"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#projectDescriptionContent"
                  aria-expanded="false"
                  aria-controls="projectDescriptionContent"
                  style={{
                    fontSize: "18px",
                    lineHeight: "1",
                    color: "#606060",
                    backgroundColor: "#F0F0F0",
                    // border: "none",
                    borderRadius: "50%",
                  }}
                >
                  &#94;
                </button>
              </div>

              {/* Collapsible Content */}
              <div className="collapse" id="projectDescriptionContent">
                <div
                  className="px-3 py-3 text-muted"
                  style={{ color: "#606060" }}
                >
                  {project?.projectDescription}
                </div>
              </div>
            </div>
            {/* project info */}
            <div
              className="container mt-3"
              style={{
                border: "1px solid #D9D9D9",
                borderRadius: "10px",
                // backgroundColor: "#F6F6F6",
                padding: "20px",
              }}
            >
              {/* Header Row */}
              <div className="d-flex justify-content-between align-items-center mb-3">
                <h5 className="mb-0" style={{ color: "#606060" }}>
                  Project Information
                </h5>
                <button
                  className=" fw-bold px-4"
                  style={{ color: "#00AFEF", fontSize: "16px" }}
                  onClick={handleUpdateProject}
                >
                  Save
                </button>
              </div>

              {/* Form Fields */}
              <form>
                <div className="row mb-3">
                  <div className="col-md-6">
                    <label className="form-label" style={{ color: "#606060" }}>
                      Owner<span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      name="ownerName"
                      className="form-control"
                      value={project.ownerName}
                      onChange={handleChange}
                      style={{ borderColor: "#C8C8C8", borderRadius: "10px" }}
                    />
                  </div>

                  <div className="col-md-6">
                    <label className="form-label" style={{ color: "#606060" }}>
                      Status<span className="text-danger">*</span>
                    </label>
                    <select
                      className="form-select"
                      name="status"
                      value={project.status}
                      onChange={handleChange}
                      style={{ borderColor: "#C8C8C8", borderRadius: "10px" }}
                    >
                      <option value="INPROGRESS">InProgress</option>
                      <option value="COMPLETED">Completed</option>
                      <option value="PENDING">Pending</option>
                    </select>
                  </div>
                </div>

                <div className="row mb-3">
                  <div className="col-md-6">
                    <label className="form-label" style={{ color: "#606060" }}>
                      Start Date
                    </label>
                    <input
                      type="date"
                      name="startDate"
                      className="form-control"
                      value={project.startDate}
                      onChange={handleChange}
                      style={{ borderColor: "#C8C8C8", borderRadius: "10px" }}
                    />
                  </div>

                  <div className="col-md-6">
                    <label className="form-label" style={{ color: "#606060" }}>
                      End Date
                    </label>
                    <input
                      type="date"
                      name="endDate"
                      className="form-control"
                      value={project.endDate}
                      onChange={handleChange}
                      style={{ borderColor: "#C8C8C8", borderRadius: "10px" }}
                    />
                  </div>
                </div>

                {/* Team Members Dropdown */}
                <div className="row mb-3">
                  <div className="col-md-6">
                    <label className="form-label" style={{ color: "#606060" }}>
                      {/* Team Members ID<span className="text-danger">*</span> */}
                    </label>
                    <select
                      className="form-select"
                      style={{ borderColor: "#C8C8C8", borderRadius: "10px" }}
                      onChange={handleAddMember}
                      defaultValue=""
                    >
                      <option value="" disabled>
                        Select Team
                      </option>
                      {teamList.map((emp) => (
                        <option key={emp.teamId} value={emp.teamId}>
                          {emp.teamName}
                        </option>
                      ))}
                    </select>

                    {/* Selected Members */}
                    <div className="mt-2 d-flex flex-wrap gap-2">
                      {teamMembersId.map((id) => {
                        const member = teamList.find(
                          (emp) => emp.teamId === id
                        );
                        return (
                          <span
                            key={id}
                            className="badge rounded-pill bg-light text-dark px-3 py-2"
                            style={{
                              border: "1px solid #ECFAFF",
                              fontWeight: "500",
                            }}
                          >

                            {member ? `${member.teamName}` : id}
                            <button
                              type="button"
                              className="btn-close ms-2"
                              onClick={() => handleRemoveMember(id)}
                              style={{ fontSize: "0.6rem" }}
                            ></button>
                          </span>
                        );
                      })}
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
          {/* col -4 */}
          <div
            className=" col-4 "
            style={{
              backgroundColor: "#F6F6F6",
              padding: "15px",
              borderRadius: "8px",
              overflowY: "auto",
              maxHeight: "400px",
            }}
          >
            <ul className="list-unstyled">
              {activityLog.map((log, index) => (
                <li className="mb-2" key={log.logId}>
                  <span style={{ color: "#606060" }}>{log.logDescription}</span>
                  <br />
                  <small style={{ color: "#B6B6B6" }}>{log.performedAt}</small>
                </li>
              ))}
            </ul>
          </div>
        </div>
        <div className="col-8 m-1">
          {/* task */}
          <div className="border rounded-3 p-3 bg-white mt-3">
            {/* Header */}
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h5 className="mb-0 fw-semibold" style={{ color: "#606060" }}>
                Tasks ({tasks.length})
              </h5>
              <div className="d-flex align-items-center gap-2">
                <button
                  className="btn btn-sm text-primary fw-bold px-3"
                  style={{
                    fontWeight: "500",
                    fontSize: "0.85rem",
                    color: "#00AFEF",
                  }}
                  onClick={() => navigate("/createtask")}
                >
                  <Icon
                    icon="material-symbols:add-rounded"
                    width="20"
                    height="20"
                  />
                  <span className="ms-1">New Task</span>
                </button>

                <button
                  className="btn btn-sm text-decoration-none"
                  onClick={() => setExpanded(!expanded)}
                  style={{
                    fontSize: "18px",
                    color: "#606060",
                    background: "none",
                    border: "none",
                    lineHeight: "1",
                  }}
                >
                  {expanded ? "˄" : "˅"}
                </button>
              </div>
            </div>
            {/* Divider */}
            <div
              style={{
                height: "1px",
                backgroundColor: "#e0e0e0",
                marginBottom: "10px",
              }}
            ></div>

            {/* Task Table */}
            {expanded && (
              <div className="rounded-2">
                {/* Header Row */}
                <div
                  className="d-flex justify-content-between align-items-center border-bottom py-2 px-1 fw-semibold"
                  style={{
                    fontSize: "0.95rem",
                    backgroundColor: "#f8f9fa",
                    color: "#606060",
                  }}
                >
                  <div style={{ flex: 1 }}>Task Name</div>
                  <div style={{ minWidth: "120px", textAlign: "center" }}>
                    Assignee
                  </div>
                  <div style={{ minWidth: "120px", textAlign: "center" }}>
                    Due Date
                  </div>
                  <div style={{ minWidth: "120px", textAlign: "center" }}>
                    Status
                  </div>
                </div>

                {/* Data Rows */}
                {currentTasks.map((task, index) => {
                  // Status styles
                  let statusStyle = {};
                  if (task.status === "COMPLETED") {
                    statusStyle = {
                      color: "#22C55E",
                      backgroundColor: "#E6FFEF",
                    };
                  } else if (task.status === "PENDING") {
                    statusStyle = {
                      color: "#0068EF",
                      backgroundColor: "#E6F1FF",
                    };
                  } else if (task.status === "IN_PROGRESS") {
                    statusStyle = {
                      color: "#C5C222",
                      backgroundColor: "#FFFBE4",
                    };
                  }

                  return (
                    <div
                      key={index}
                      className="d-flex justify-content-between align-items-center border-bottom py-2 px-1"
                      style={{ fontSize: "0.95rem" }}
                    >
                      {/* Task Name */}
                      <div className="fw-medium" style={{ flex: 1 }}>
                        {task.taskTitle}
                      </div>

                      {/* Assignee */}
                      <div
                        className="small px-2 py-1 rounded"
                        style={{
                          // backgroundColor: "#f8f9fa",
                          color: "#6c757d",
                          fontWeight: "500",
                          minWidth: "120px",
                          textAlign: "center",
                        }}
                      >
                        {task.assignedToEmployeeName}
                      </div>

                      {/* Due Date */}
                      <div
                        className="small px-2 py-1 rounded"
                        style={{
                          // backgroundColor: "#eef",
                          color: "#555",
                          fontWeight: "500",
                          minWidth: "120px",
                          textAlign: "center",
                        }}
                      >
                        {task.endDate}
                      </div>

                      {/* Status */}
                      <span
                        className="px-3 py-1 badge rounded-pill"
                        style={{
                          ...statusStyle,
                          fontSize: "0.75rem",
                          fontWeight: "600",
                          minWidth: "120px",
                          textAlign: "center",
                          display: "inline-block",
                        }}
                      >
                        {task.status}
                      </span>
                    </div>
                  );
                })}
              </div>
            )}

            {/* Pagination */}
            {expanded && (
              <nav className="mt-3">
                <ul className="pagination justify-content-center">
                  {[...Array(totalPages)].map((_, i) => (
                    <li
                      key={i}
                      className={`page-item ${currentPage === i + 1 ? "active" : ""
                        }`}
                      style={{ margin: "0 5px" }}
                    >
                      <button
                        className="page-link"
                        onClick={() => handlePageChange(i + 1)}
                        style={{
                          borderRadius: "50%", // circle shape
                          width: "36px",
                          height: "36px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          padding: 0,
                          backgroundColor:
                            currentPage === i + 1 ? "#909090" : "transparent",
                          color: currentPage === i + 1 ? "#fff" : "#909090",
                          border: "1px solid #909090",
                          fontWeight: "500",
                        }}
                      >
                        {i + 1}
                      </button>
                    </li>
                  ))}
                </ul>
              </nav>
            )}
          </div>
          {/* comments */}
          <div
            className="border rounded-3 p-3 mt-4 bg-white"
            style={{ borderColor: "#D9D9D9" }}
          >
            <h6 className="mb-3 fw-semibold" style={{ color: "#606060" }}>
              Comments
            </h6>

            {/* Comments Section */}
            {project?.taskComments && project.taskComments.length > 0 ? (
              project.taskComments.map((comment, index) => (
                <div key={index} className="mb-3">
                  <p
                    className="mb-1 text-muted"
                    style={{ fontSize: "0.95rem" }}
                  >
                    {comment.text} @{comment.author}
                  </p>
                  <small className="text-secondary">
                    {comment.createdBy}.{" "}
                    {new Date(comment.createdAt).toLocaleString()}
                  </small>
                </div>
              ))
            ) : (
              <p className="text-muted fst-italic">No comments yet</p>
            )}

            {/* input field */}

            {/* <div className="d-flex align-items-center gap-2">
    <input
      type="text"
      className="form-control"
      placeholder="Enter comment..."
      value={comment}
      onChange={(e) => setComment(e.target.value)}
      style={{
        borderRadius: "10px",
        borderColor: "#C8C8C8",
        fontSize: "0.95rem",
      }}
    />


    <button
      type="button"
      className="btn"
      onClick={handleMentionClick}
      style={{
        background: "none",
        border: "none",
        color: "#606060",
      }}
    >
      <Icon icon="ci:mention" width="22" height="22" />
    </button>


    <button
      type="button"
      className="btn"
      onClick={handleSend}
      style={{
        backgroundColor: "#00AFEF",
        borderRadius: "8px",
        padding: "6px 10px",
      }}
    >
      <Icon
        icon="mingcute:send-line"
        width="22"
        height="22"
        color="#fff"
      />
    </button>
  </div> */}

            {/* {showMentions && (
    <div
      className="mt-2 border rounded-2 p-2"
      style={{
        backgroundColor: "#F9F9F9",
        maxHeight: "150px",
        overflowY: "auto",
      }}
    >
      {teamList.map((emp) => (
        <div
          key={emp.id}
          className="py-1 px-2 text-muted"
          style={{ cursor: "pointer" }}
          onClick={() => handleSelectEmployee(emp)}
        >
          @{emp.firstName} {emp.lastName}
        </div>
      ))}
    </div>
  )} */}
          </div>
        </div>
      </div>
    </Layout>
  );
}

export default ProjectDesc;
